import { render, staticRenderFns } from "./OnboardingIncorpInit.vue?vue&type=template&id=4355d599&"
import script from "./OnboardingIncorpInit.vue?vue&type=script&lang=js&"
export * from "./OnboardingIncorpInit.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingIncorpInit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports